import { useContext, useEffect, useState } from "react";
import { useService } from "../../../../hooks";
import { AppContext } from "../../../../context";

export const useSettings = () => {
  const { fetchByAttr, save, update } = useService("Data", "setting");
  const appContext = useContext(AppContext);
  const showPreloader = appContext?.actions?.showPreloader || (() => {});
  const hidePreloader = appContext?.actions?.hidePreloader || (() => {});
  const updateAppLogo = appContext?.actions?.setLogo || (() => {});
  const updateAppLogoWhite = appContext?.actions?.setLogoWhite || (() => {});
  const { showAlert } = useService("Misc");
  const [settings, setSettings] = useState<any>({});
  const [logo, setLogo] = useState("");
  const [logoWhite, setLogoWhite] = useState("");

  useEffect(() => {
    getSettings();
  }, []);

  const getSettings = async () => {
    showPreloader();
    const logoResult = await fetchByAttr({ key: "logo" });
    const logoWhiteResult = await fetchByAttr({ key: "logoWhite" });
    hidePreloader();
    if (logoResult.status && logoResult.data.length > 0) {
      setLogo(logoResult.data[0].value);
      setSettings((prev) => ({ ...prev, logo: logoResult.data[0] }));
    }
    if (logoWhiteResult.status && logoWhiteResult.data.length > 0) {
      setLogoWhite(logoWhiteResult.data[0].value);
      setSettings((prev) => ({ ...prev, logoWhite: logoWhiteResult.data[0] }));
    }
  };

  const updateSetting = async (key: string, value: string, existingSetting: any) => {
    showPreloader();
    let result;
    if (existingSetting) {
      const updatedData = { ...existingSetting, value };
      result = await update({
        query: JSON.stringify({ id: existingSetting.id }),
        settingData: JSON.stringify(updatedData),
      });
    } else {
      result = await save({ key, value });
    }
    hidePreloader();
    if (result.status) {
      showAlert({ type: "success", msg: `${key} updated successfully!` });
      if (key === "logo") updateAppLogo(value);
      if (key === "logoWhite") updateAppLogoWhite(value);
      getSettings();
    } else {
      showAlert({ type: "error", msg: `Failed to update ${key}!` });
    }
  };

  return {
    logo,
    setLogo,
    logoWhite,
    setLogoWhite,
    updateLogo: (val: string) => updateSetting("logo", val, settings.logo),
    updateLogoWhite: (val: string) => updateSetting("logoWhite", val, settings.logoWhite),
  };
};
